<template lang="pug">
  app-modal(
    :titulo="titulo",
    v-if="showModal && !this.analiseSemDespacho"
    :width="1000"
    @closeModal="closeModal"
  )
    template(slot="body")
      app-search-despachos(
        @search="search",
        @input="search",
        @clear="clear",
      )
      div(v-if="modelos.length === 0")
        p.center Ainda não há modelos disponíveis
      div.container-modelo
        div.item(v-for='item in modelos', :key="item.id")
          div(@click='selectModelo(item.id)')
            el-card.cursor-pointer(:class="{ active: item.id === selectedModelo.id }")
              span.descricao {{ item.descricaoTexto }}
              p.border-bottom
              p(v-html="item.textoModelo")
    template(slot="footer")
      app-utilizar-buttons(@cancel="closeModal", @confirm="save", :textModel="selectedModelo.textoModelo", :textButtonConfirm="'Encaminhar processo(s)'")
</template>

<script>
import { mapActions } from 'vuex'

import AppUtilizarButtons from '../AppUtilizarButtons'
import AppSearchDespachos from '../AppSearchDespachos'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppUtilizarButtons,
    AppSearchDespachos,
    AppModal
  },
  props: {
    tiposModelo: {
      type: Array,
      required: true
    },
    idsProcessos: {
      type: Array,
      required: false
    },
    showModal: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    analiseSemDespacho: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      selectedModelo: {},
      filtro: { parametro: '', tiposModelo: this.tiposModelo },
      modelos: []
    }
  },

  async created () {
    if (!this.analiseSemDespacho) {
      const data = await this.findByFiltroSelecao(this.filtro)
      this.modelos = data
    } else {
      this.salvarSemMotivo()
    }
  },

  methods: {
    ...mapActions({
      findByFiltroSelecao: 'modeloDespacho/findByFiltroSelecao',
      findByFiltroSelecaoAndProcesso: 'despacho/findByFiltroSelecaoAndProcesso',
      analiseConjuta: 'processo/analiseConjunta'
    }),

    closeModal () {
      this.$emit('closeModal')
    },
    checkValidacao () {
      const valido = this.selectedModelo.textoModelo
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_WARNING, 'Por favor, selecione um modelo.')
        return false
      }
      return true
    },
    async save () {
      if (!this.checkValidacao()) {
        return
      }
      this.confirmBox(this.$messages.ENCAMINHAR_DADOS, this.$messages.TITULO_ANALISE,
        async () => {
          const response = await this.analiseConjuta({idProcessos: this.idsProcessos, motivo: this.selectedModelo.textoModelo})
          if (response && !response.status) {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) analisado(s) com sucesso')
          }
          this.closeModal()
        },
        () => {
        })
    },

    async salvarSemMotivo () {
      this.confirmBox(this.$messages.ENCAMINHAR_DADOS, this.$messages.TITULO_ANALISE,
        async () => {
          const response = await this.analiseConjuta({idProcessos: this.idsProcessos, motivo: 'Análise automática'})
          if (response && !response.status) {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) analisado(s) com sucesso')
          }
          this.closeModal()
        },
        () => {
          this.$emit('cancelaTramitacao')
        })
    },

    async search (param) {
      this.filtro.parametro = param
      let data = await this.findByFiltroSelecao(this.filtro)
      this.modelos = data
    },

    clear () {

    },

    selectModelo (id) {
      if (this.selectedModelo.id === id) {
        this.selectedModelo = {}
      } else {
        this.selectedModelo = this.modelos.find(x => x.id === id)
      }
    }
  }
}

</script>

<style scoped lang="scss">
.center {
  text-align: center;
  margin-top: 20px !important;

}
p.message {
  width: 80%;
  margin: 0 auto;
}

.center {
  margin-top: 40px !important;
  text-align: center;
}

.item {
  margin: 5px;
  width: 310px;
}

.el-card {
  max-width: 100%;
  height: 350px;
  font-size: 12px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.container-modelo {
  padding-top: 22px;
  display: flex;
  flex-wrap: wrap;
}
.descricao {
  font-weight: bold;
  font-size: 16px;
}

.border-bottom {
  padding-bottom: 10px;
  border-bottom: solid 1px #A7B2BA;
}

.active {
  background: rgb(223, 223, 223) !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalAnaliseConjunta.vue